import { Container } from "inversify";
import "reflect-metadata";
import TYPES from "./TYPES";
import { KotennaApi, KotennaApiv1, KotennaConfig } from "./lib/kotenna/KotennaApi";
import { ConsoleImplUno, ConsoleUI } from "./utils/ConsoleUI";
import { VHostWorker } from "./entities/VHost";
import { AliasWorker } from "./entities/Alias";
import { ServiceConfigurationToml } from "./utils/ServiceConfiguration";
import { CloudProviderWorker } from "./providers/CloudProviderWorker";
import { DigitalOceanWorker } from "./providers/DigitalOceanWorker";
import { ProviderWorker } from "./entities/Provider";
import { AzurevmWorker } from "./providers/AzurevmWorker";
import { Ec2Worker } from "./providers/EC2Worker";
import { CFWorker } from "./providers/CFWorker";
import { AuthenticationServer } from "./signup/AuthenticationServer";
import { AppDeployer } from "./apps/AppDeployer";
import { DoWordpress } from "./apps/digitalocean/DoWordpress";

const container = new Container();

container.bind<ConsoleUI>(TYPES.ConsoleUI).to(ConsoleImplUno).inSingletonScope();

container.bind<VHostWorker>(TYPES.VHostWorker).to(VHostWorker);
container.bind<AliasWorker>(TYPES.AliasWorker).to(AliasWorker);
container.bind<ProviderWorker>(TYPES.ProviderWorker).to(ProviderWorker);

// Bind the Kotenna auth from ENV variables
// container.bind<KotennaConfig>(TYPES.KotennaConfig).toConstantValue({ USER: process.env.KOTENNA_USER!, PASSWORD: process.env.KOTENNA_PASSWORD! });
container.bind<ServiceConfigurationToml>(TYPES.ServiceConfiguration).to(ServiceConfigurationToml).inSingletonScope();
container.bind<KotennaApi>(TYPES.KotennaApi).to(KotennaApiv1).inSingletonScope();
container.bind<AuthenticationServer>(TYPES.AuthenticationServer).to(AuthenticationServer);

container.bind<CloudProviderWorker>(TYPES.CloudProvidertWorker('digitalocean')).to(DigitalOceanWorker);
container.bind<CloudProviderWorker>(TYPES.CloudProvidertWorker('azure/vm')).to(AzurevmWorker);
container.bind<CloudProviderWorker>(TYPES.CloudProvidertWorker('awsec2')).to(Ec2Worker);
container.bind<CloudProviderWorker>(TYPES.CloudProvidertWorker('awscf')).to(CFWorker);

container.bind<AppDeployer>(TYPES.AppDigitalOceanWordpress).to(DoWordpress);

export default container;